import { GAME_ID, REDUX_ACTIONS } from 'a/zoomBoom/data/constants';

const initialState = {
  isActive: false,
};

const targetReducer = (state = initialState, { gameId, type, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SET_TARGET_IS_ACTIVE:
      return {
        ...state,
        isActive: payload,
      };

    default:
      return state;
  }
};

export default targetReducer;
